import { Collapse } from 'antd';
const { Panel } = Collapse;

function AppFAQ() {
  return (
    <div className='block faqPage'>
      <div className='container'>
        <h2>FAQ</h2>
        <Collapse accordion defaultActiveKey={['1']}>
          <Panel header="Delivery and collection information" key="1">
            <p>At Grocery, we make shopping convenient with reliable delivery and collection options. Enjoy fast, contactless home delivery or choose our easy pickup service at your preferred location. Orders are carefully packed to ensure freshness and quality, arriving on time and ready to enjoy. Whether you need groceries for daily meals or special occasions, our flexible options save you time and effort. Track your order in real-time, select delivery slots that suit your schedule, and experience a seamless, stress-free shopping experience. Grocery is committed to making your grocery shopping simple, convenient, and tailored to your lifestyle.</p>
          </Panel>
          <Panel header="What do I need to know about ordering online?" key="2">
            <p>At Grocery, we strive to make your online shopping experience as smooth as possible. Here are some key points to keep in mind when ordering online:</p>
            <ul>
              <li>Browse our extensive selection of products and add your favorites to the cart.</li>
              <li>Review your cart before checkout to ensure you have everything you need.</li>
              <li>Choose your preferred delivery or pickup option at checkout.</li>
              <li>Provide accurate contact and delivery information for a seamless experience.</li>
              <li>If you have any questions or need assistance, our customer support team is here to help.</li>
            </ul>
          </Panel>
          <Panel header="Returns and refunds" key="3">
            <p>At Grocery, we want you to be completely satisfied with your purchase. If you need to return an item or request a refund, please follow these guidelines:</p>
            <ul>
              <li>Contact our customer support team within 30 days of receiving your order.</li>
              <li>Provide your order number and details about the item you wish to return.</li>
              <li>Items must be in their original condition and packaging to be eligible for a refund.</li>
              <li>Refunds will be processed within 7-10 business days after we receive the returned item.</li>
            </ul>
          </Panel>
          <Panel header="Managing my account" key="4">
            <p>At Grocery, we want to ensure you have full control over your account. Here are some key features:</p>
            <ul>
              <li>Update your personal information, including your address and payment methods.</li>
              <li>View your order history and track the status of current orders.</li>
              <li>Manage your subscription preferences and delivery schedules.</li>
              <li>Access exclusive offers and promotions available to account holders.</li>
              <li>If you have any questions or need assistance, our customer support team is here to help.</li>
            </ul>
          </Panel>
          <Panel header="Technical issues" key="5">
            <p>At Grocery, we understand that technical issues can be frustrating. If you encounter any problems while using our website or app, please follow these steps:</p>
            <ul>
              <li>Check our help center for troubleshooting tips and FAQs.</li>
              <li>Ensure you are using the latest version of our app or browser.</li>
              <li>Clear your browser cache and cookies, then try again.</li>
              <li>If the issue persists, contact our customer support team with details about the problem.</li>
            </ul>
          </Panel>
          <Panel header="Terms and conditions" key="6">
            <p>Welcome to Grocery. By using our website and services, you agree to the following terms. All products are subject to availability and may vary in price. Orders must be placed through our official website or app. Delivery and collection times are estimates; we are not responsible for delays beyond our control. Customers must provide accurate information for orders. Payments are processed securely, and all transactions must comply with applicable laws. We reserve the right to modify, suspend, or discontinue services at any time. By using Grocery, you accept these terms and agree to our policies.</p>
          </Panel>
          <Panel header="Ratings and reviews" key="7">
            <p>At Grocery, we value your feedback. Here’s how you can leave a rating or review:</p>
            <ul>
              <li>Visit the product page for the item you want to review.</li>
              <li>Click on the "Write a Review" button.</li>
              <li>Share your experience, rate the product, and submit your review.</li>
              <li>Our team reviews all submissions to ensure quality and relevance.</li>
              <li>Inappropriate content may be removed, and repeat offenders may be banned.</li>
            </ul>
          </Panel>
        </Collapse>
      </div>
    </div>
  );
}

export default AppFAQ;